export interface LocationPermitComplianceAddFormModel {
  idCaseLocationPermitComplianceMap?: string;
  webId: string;
  finalActDocumentName: string;
  classification: string;
  finalActFileNumber: string;
  finalDocumentAdmissionDate?: Date;
  solutionType: string;
  caseCategory: string;
  executionDate?: Date;
  effectivenessDate?: Date;
  dataFetched: boolean;
  authority: string;
  administrativeUnit: string;
  authorityOfficeOldName: string;
}

export interface LocationPermitComplianceModel {
  finalActBasedOnLocationPermit: boolean;
}

export const initialLocationPermitComplianceAddForm = {
  webId: '',
  finalActDocumentName: '',
  classification: '',
  finalActFileNumber: '',
  finalDocumentAdmissionDate: null,
  caseCategory: '',
  executionDate: null,
  effectivenessDate: null,
  dataFetched: false,
} as LocationPermitComplianceAddFormModel;

export interface LocationPermitCompliancePage {
  totalElements: number;
  content: LocationPermitComplianceAddFormModel[];
}

export const initialLocationPermitComplianceModel = {
  finalActBasedOnLocationPermit: false
}
